import * as React from 'react';
import { useSelector } from 'react-redux';
import { ShowcaseCat } from '../../components/ShowcaseCat';
import { selectMediaBanksNumber } from '../../selectors/media/banksNumber';
import { IShowcase } from '../../types/showcase/props';

export function ShowcaseCatContainer(props: IShowcase) {
  const banksNumber = useSelector(selectMediaBanksNumber);

  return <ShowcaseCat {...props} banksNumber={banksNumber} />;
}
